<template>
    <div class="app-sidenav">
        <div class="app-sidenav__close" @click="closeSidenav">
            <common-icon name="close" size="huge"></common-icon>
        </div>

        <router-link :to="{ name: RoutesEnum.INDEX.HOME }" class="app-sidenav__logo">
            <div v-if="$auth.isSubdomainActive()" class="app-sidenav__logo--subdomain">
                <common-company-avatar
                    :withBorder="true"
                    :company="Store.getters['data/getSubdomainCompany']"
                    :size="isSmall ? 'micro' : 'small'"
                ></common-company-avatar>
                <p v-if="!isSmall">{{ companyName }}</p>
            </div>
            <common-icon v-else name="logo" size="extra-large"></common-icon>
        </router-link>
        <div class="app-sidenav__main-menu">
            <app-main-menu :isSmall="isSmall"></app-main-menu>
        </div>
        <div v-if="!$auth.isSubdomainActive()" class="app-sidenav__powered-by" @click="goToCodeBustersWebsite()">
            <common-icon name="codebusters" size="large"></common-icon>
            <span v-if="!isSmall || isSidenavOpen" class="app-sidenav__powered-by--codebusters">CodeBusters</span>
        </div>
    </div>
</template>

<script>
    import AppMainMenu from 'components/layouts/components/main-layout/AppMainMenu'
    import RoutesEnum from 'enums/routes.enum'
    import Store from '~/store'

    export default {
        components: {
            AppMainMenu,
        },

        props: {
            isSmall: { type: Boolean, default: false },
            isSidenavOpen: { type: Boolean, required: true },
        },

        data: () => ({ RoutesEnum, Store: Store }),

        computed: {
            companyName() {
                return Store.getters['data/getSubdomainCompany'].name
            },
        },

        methods: {
            closeSidenav() {
                this.emitEvent({ name: 'close-sidenav' })
            },
            goToCodeBustersWebsite() {
                window.open('https://codebuste.rs', '_blank')
            },
        },

        watch: {
            isSidenavOpen() {
                if (this.isSidenavOpen) {
                    document.body.classList.add('sidemenu-open')
                } else {
                    document.body.classList.remove('sidemenu-open')
                }
            },
        },
    }
</script>
